<template>
  <section>
    <el-row
      v-if="canAction('see_master_approve_buttons')"
      class="bids-list-approve-filter"
      :gutter="24"
    >
      <el-col style="margin: 16px 0" :span="4">
        <b>ВЫБРАНО {{ checkedRequest.length }} АВТО</b>
      </el-col>
      <el-col class="auto-list_col" :span="4">
        <el-button
          :disabled="!checkedRequest.length"
          type="info"
          plain
          @click="$emit('openSmsDialog')"
        >
          ОТПРАВИТЬ СМС
        </el-button>
      </el-col>
      <el-col class="auto-list_col" :span="3">
        <el-button
          :disabled="!checkedRequest.length"
          type="info"
          plain
          @click="sendApprove(2)"
        >
          ОТКАЗАТЬ
        </el-button>
      </el-col>

      <el-col class="auto-list_col" :span="3">
        <el-button
          :disabled="!checkedRequest.length"
          type="info"
          plain
          @click="sendApprove(1)"
        >
          УТВЕРДИТЬ
        </el-button>
      </el-col>
    </el-row>
  </section>
</template>

<script>
export default {
  name: 'ApproveResponse',
  props: {
    sendApprove: {
      type: Function,
      default: () => {},
    },
    checkedRequest: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="sass">
.bids-list-approve-filter
  display: flex
  justify-content: flex-end
  font-family: Rubik, sans-serif
  font-style: normal
  font-weight: 500
  font-size: 14px
  line-height: 17px
  text-align: center
  text-transform: uppercase

  .rejection, .approve
    background: #E9E9E9
    color: #778CA2
    border-radius: 4px

  a
    cursor: pointer
    text-decoration: underline
</style>
